import { FieldPattern } from '..';

import { DATE_PICKER } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class DatePickerFieldModel extends FormFieldWithInitialValue {
  readonly type: string = DATE_PICKER;
  dateFormat?: string;
  maxDate?: string;
  minDate?: string;
  maxVisibilityTime?: string;
  showMonthYearPicker?: boolean;
  excludeDates?: Date[];
  isDependent?: boolean;
  dependentOnField?: string;
  constructor(datePickerFieldData: FormFieldsType, initialValue = '') {
    super(datePickerFieldData, initialValue);
    this.dateFormat = datePickerFieldData.date_format;
    this.maxDate = datePickerFieldData.max_date;
    this.minDate = datePickerFieldData.min_date;
    this.maxVisibilityTime = datePickerFieldData.max_visibility_time;
    this.showMonthYearPicker = datePickerFieldData.show_month_year_picker;
    this.excludeDates = this.getFormattedExcludedDays(
      datePickerFieldData.exclude_dates
    );
    this.isDependent = datePickerFieldData.is_dependent ?? false;
    this.dependentOnField = datePickerFieldData.dependent_on_field ?? '';
  }
  getFormattedExcludedDays = (excludedDates) => {
    if (excludedDates) {
      return excludedDates.map((eachDate) => new Date(eachDate));
    }
    return [];
  };
  match<T>(p: FieldPattern<T>): T {
    return p.DatePickerField(this);
  }
}

export default DatePickerFieldModel;
